import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Store } from '@ngrx/store'
import { AppState } from "../../reducers";
import { SponsorActions } from "./sponsor.actions"
import {
	CategoryApi,
	EventApi,
	PriceApi,
	SeatingplanApi,
	SponsorApi,
	TicketQuotaApi,
	VenueApi
} from "../../services/webservice";
import { PriceLevelService } from "../../services"

@Injectable()
export class SponsorResolver implements Resolve<void> {

	constructor(
		private store: Store<AppState>,
		private sponsorActions: SponsorActions
	) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		const sponsorId = route.params["id"]
		return this.store.dispatch(this.sponsorActions.loadSponsor(sponsorId))
	}
}

@Injectable()
export class SponsorCodeListResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private sponsorActions: SponsorActions
	) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		const sponsorId = route.parent.params["id"]
		return this.store.dispatch(this.sponsorActions.loadSponsorCodes(sponsorId))
	}
}


@Injectable()
export class CodeCreateResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private sponsorActions: SponsorActions
	) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		return this.store.dispatch(this.sponsorActions.sponsorCodeLoaded(null))
	}
}

@Injectable()
export class CodeEditResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private sponsorActions: SponsorActions
	) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		const sponsorCodeId = route.params["codeId"];
		return this.store.dispatch(this.sponsorActions.loadSponsorCodeById(sponsorCodeId))
	}
}

@Injectable()
export class CodeUsageListResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private sponsorActions: SponsorActions
	) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		const sponsorCodeId = route.params["codeId"];
		return this.store.dispatch(this.sponsorActions.loadSponsorCodeUsages(sponsorCodeId))
	}
}

@Injectable()
export class CodeUsageCreateResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private sponsorActions: SponsorActions
	) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		return this.store.dispatch(this.sponsorActions.sponsorCodeUsageLoaded(null))
	}
}

@Injectable()
export class CodeUsageEditResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private sponsorActions: SponsorActions,
		private sponsorApi: SponsorApi
	) {
	}

	public loadCodeUsageData(codeUsageId) {
		this.sponsorApi.getSponsorCodeUsageById(codeUsageId).subscribe(codeUsage => {
			this.store.dispatch(this.sponsorActions.sponsorCodeUsageLoaded(codeUsage))
			this.store.dispatch(this.sponsorActions.loadSeatsForCodeUsage(codeUsageId))
			this.store.dispatch(this.sponsorActions.loadFreeSeatingsForCodeUsage(codeUsageId))
			this.sponsorApi.fetchReservationsByEventUuidIntoStore(codeUsage.eventUuid)
		})
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		const codeUsageId = route.params["codeUsageId"];
		this.loadCodeUsageData(codeUsageId)
	}
}

@Injectable()
export class CodeUsageEventListResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private sponsorActions: SponsorActions
	) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		return this.store.dispatch(this.sponsorActions.loadCodeUsageEventList())
	}
}

@Injectable()
export class SeatingplanResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private eventApi: EventApi,
		private sponsorApi: SponsorApi,
		private sponsorActions: SponsorActions,
		// private venueActions: VenueActions,
		// private categoryActions: CategoryActions,
		// private ticketQuotaActions: TicketQuotaActions,
		private categoryApi: CategoryApi,
		private venueApi: VenueApi,
		private priceApi: PriceApi,
		private ticketQuotaApi: TicketQuotaApi,
		private priceLevelService: PriceLevelService,
		private seatingplanApi: SeatingplanApi,
	) {
	}

	public loadFullEvent(eventId: string, codeUsageId: string) {
		this.sponsorApi.getSponsorCodeUsageById(codeUsageId).subscribe(codeUsage => {
			this.priceApi.findByUuid(codeUsage.plUuid).subscribe(pl => {
				this.store.dispatch(this.sponsorActions.spPriceLevelLoaded(pl))
			})
			this.categoryApi.findByUuid(codeUsage.catUuid).subscribe(category => {
				this.store.dispatch(this.sponsorActions.spCategoryLoaded(category))
				}
			)
		})
		this.eventApi.getEventById(eventId).subscribe(event => {
			this.store.dispatch(this.sponsorActions.spEventLoaded(event))
			this.venueApi.getVenueById(event.venueId.toString()).subscribe(venue => this.store.dispatch(this.sponsorActions.spVenueLoaded(venue)))
			this.seatingplanApi.loadSeatingplanByUuid(event.seatingplanUuid).subscribe(seatingplan => {
				this.store.dispatch(this.sponsorActions.seatingplanLoaded(seatingplan));
			});

			this.ticketQuotaApi.getTicketQuotas(event._links.ticketQuotas.href)
				.subscribe(ticketQuotas => this.store.dispatch(this.sponsorActions.ticketQuotasLoaded(ticketQuotas._embedded.ticketQuotas))
				)
		})
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
		const codeUsageId = route.params["codeUsageId"];
		const eventId = route.params["eventId"]
		this.loadFullEvent(eventId, codeUsageId);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/sponsors/sponsor.resolver.ts